import { z } from 'zod';
import { CREATED_RANGE_SHAPE, PageQuerySchema, UuidSchema } from './common';

/** §13, §18 ТЗ, сценарий 33. Раздел «Аудит действий»: кто, когда, что изменил. */

export const AuditEventViewSchema = z.object({
  id: UuidSchema,
  actorType: z.enum(['EMPLOYEE', 'PERSON', 'SYSTEM']),
  actorId: z.string().nullable(),
  actorName: z.string().nullable(),
  action: z.string(),
  entityType: z.string(),
  entityId: z.string(),
  /** объект, к которому относится событие; null у внесистемных (роли, настройки) */
  projectId: z.string().nullable(),
  /** безопасный набор изменений (§18), структура зависит от действия */
  changes: z.unknown(),
  ip: z.string().nullable(),
  createdAt: z.string().datetime(),
});
export type AuditEventView = z.infer<typeof AuditEventViewSchema>;

export const ListAuditQuerySchema = PageQuerySchema.extend({
  action: z.string().max(100).optional(),
  entityType: z.string().max(100).optional(),
  entityId: z.string().max(100).optional(),
  actorId: z.string().max(100).optional(),
  projectId: UuidSchema.optional(),
  ...CREATED_RANGE_SHAPE,
});
export type ListAuditQuery = z.infer<typeof ListAuditQuerySchema>;
